export default __webpack_public_path__ + "static/BanImg5-9db622947b95e7f9e4e0571e4f66d178.webp";